import { useRoute } from '@react-navigation/native';
import { useMemo } from 'react';
import useCallbackWithCtx from 'src/hooks/useCallbackUtils/useCallbackWithCtx';
import { isWeb } from 'src/utils/platform';
import { useTopicPlaylist } from '../../graphql/question/getQuestionPlaylistForTopic';
import { useQuestionListForTopicQuery, } from '../../graphql/question/getQuestionsForTopic';
import { useSubjectDetailsQuery } from '../../graphql/subject/getDetails';
import buildEPQuestionNavParams from '../../navigation/buildEPQuestionNavParams';
import { pageAnalytics } from './analytics';
export default function useData() {
    const route = useRoute();
    const { examLevel, subject, ancestorID, topic } = route.params;
    // Since Topic can have spaces & '&' characters
    const decodedTopic = decodeURIComponent(topic);
    const [listQueryState, listQueryActions] = useQuestionListForTopicQuery();
    const listQueryVariables = useMemo(() => ({
        topic,
        ancestorID,
    }), [topic, ancestorID]);
    const [subjectDetailsQueryState] = useSubjectDetailsQuery(ancestorID, {
        skip: !!subject,
    });
    const buildQuestionNavParams = useCallbackWithCtx((ctx, question, index) => buildEPQuestionNavParams({
        ...(!isWeb && {
            examLevel: ctx.examLevel,
            subject: ctx.subject,
            question,
        }),
        questionID: question.id,
        navigatedFrom: 'TOPIC_QUESTIONS',
        navigationData: {
            ancestorID: ctx.ancestorID,
            topic: ctx.topic,
            sequence: index,
        },
    }), { subject, examLevel, topic: decodedTopic, ancestorID });
    const trackQuestionPress = useCallbackWithCtx(() => {
        pageAnalytics.setWidget('QuestionList').setTarget('Question').click();
    }, []);
    const getQuestionDetailsTo = useCallbackWithCtx((ctx, question, index) => ({
        screen: 'EP_Question',
        params: ctx.buildQuestionNavParams(question, index),
    }), { buildQuestionNavParams });
    const [playlistState, playlistActions] = useTopicPlaylist(ancestorID, topic);
    const state = {
        topic: decodedTopic,
        playlist: playlistState,
        listQuery: listQueryState,
        listQueryVariables,
        subjectDetailsQuery: subjectDetailsQueryState,
        subject: subject ?? subjectDetailsQueryState.data?.ep_subjectDetails,
        examLevel: examLevel ??
            subjectDetailsQueryState.data?.ep_subjectDetails.ancestorsDetails
                .examLevel,
    };
    const actions = {
        listQuery: listQueryActions,
        playlist: playlistActions,
        trackQuestionPress,
        getQuestionDetailsTo,
    };
    return [state, actions];
}
